module.exports = __webpack_public_path__ + "proximanova-regular-webfont.2ccc4f85c08552a7f405.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/sherr/Desktop/bsf-website/src/assets/fonts/proximanova-regular-webfont.woff
// module id = ../../../../../src/assets/fonts/proximanova-regular-webfont.woff
// module chunks = 1